<template>
  <div class="warning-card">
    <div class="background"></div>
    <div class="warning-content">
        <div class="warning-image">
            <img src="../../assets/images/warning.png" alt="warning" />
        </div>
        <div class="warning-text">
        {{ warningMessage }}
        </div>
        <div class="button-container">
            <button @click="confirm">确定</button>
            <button @click="cancel">取消</button>
        </div>
    
    </div>
   
  </div>
</template>

<script>
export default {
  props: {
    warningMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', true);
    },
    cancel() {
      this.$emit('confirm', false);
    }
  }
};
</script>

<style scoped>
.warning-card{
  z-index: 100;
}
.background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  z-index: 10;
}

.warning-content {
  position: fixed;
  width: 433px;
  height: 153px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background-color: white;
  .warning-image {
    position: absolute;
    top: 40px;
    left: 30px;
    img {
      width: 22px;
      height: 22px;
    }
  }
  .warning-text {
    margin-top: 40px;
    margin-left: 60px;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  font-family: 'PingFang SC';
  font-weight: bold;
  font-size: 16px;
  z-index: 20;
}

.button-container {
  position: absolute;
    bottom: 20px;
    right: 20px;
  display: flex;
  justify-content: flex-end;
  button {
    width: 65px;
    height: 32px;
    margin-left: 10px;
    background: white;
    border-width: 1px;
    border-color: #383434;
    border-radius: 5px;
    
}
button:hover {
  font-weight: bold;
  color:red;
  background: #F5F5F5;
}
}


</style>
